export default function PageLoader() {

  // ========================
  // LOADER UI COMPONENT
  // ========================

  return (
    <div className="page-loader">

      {/* ======================== */}
      {/* LOADING TEXT */}
      {/* ======================== */}
      Loading...

    </div>
  );
}